import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { TextField, InputLabel } from "@mui/material";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";

export default function TaskChatFormPzitb({
  userData,
  author,
  title,
  content,
  error,
  handleAuthorChange,
  handleTitleChange,
  handleContentChange,
  handleSubmit,
}) {
  return (
    <div
      style={{
        backgroundColor: "#e8f5e9", // pastelowo zielone tło (MUI green[50])
        border: "1px solid #a5d6a7", // jasna zielona ramka
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "20px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)", // lekki cień
      }}
    >
      <Row style={{ marginBottom }}>
        <Col>
          <InputLabel id="content-label">
            Korespondencja PZITB - autor:
          </InputLabel>
          <Form.Group controlId="formTitle">
            <TextField
              type="text"
              name="author"
              label="Autor korespondencji"
              fullWidth
              variant="outlined"
              value={author}
              onChange={handleAuthorChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
        </Col>
        <Col>
          <InputLabel id="content-label">
            Korespondencja PZITB od: <b>{userData.fullName}</b>
          </InputLabel>
          <Form.Group controlId="formTitle">
            <TextField
              type="text"
              name="title"
              label="Temat korespondencji PZITB"
              fullWidth
              variant="outlined"
              value={title}
              onChange={handleTitleChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row style={{ marginBottom }}>
        <Col>
          <Form.Group controlId="formContent">
            <TextField
              type="text"
              name="content"
              label="Treść korespondencji"
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={content}
              onChange={handleContentChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>

          <div style={{ marginTop: "15px" }}>
            <Button
              type="submit"
              variant="contained"
              color="success"
              onClick={handleSubmit}
            >
              Wyślij korespondencję PZITB
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
